import axios from "axios";  

class AddressSearch {    
	constructor() {
	}

  async get(infosSearch) {
    let r;
    let url = infosSearch.url + infosSearch.txtsearch + (infosSearch.complurl.length > 0 ?  "&" + infosSearch.complurl + Cesium.Ion.defaultAccessToken : "" ); 


    const isReverseSearch = this.isReverse(infosSearch.txtsearch) ;
    if(isReverseSearch && infosSearch.urlReverse != undefined) {
      
      const txtReverse = this.convertToReverse(infosSearch.txtsearch);
      url = infosSearch.urlReverse + txtReverse + (infosSearch.complurl.length > 0 ?  "&" + infosSearch.complurl + Cesium.Ion.defaultAccessToken : "" ); 

    }
    
    r = axios({
      method: 'get',
      url, 
    });

    return r.then((response) => { 
      if (response.status === 200) {
        if(response.query === undefined || response.query === null )
          response.data.query = infosSearch.txtsearch; 

        // pour la recherche géocodée : on ajoute à la liste des rés. ce qui a été cherché.
        // => une adresse postale pourrait ne pas correspondre, mais on peut qd mm se rendre sur cette position
        if(isReverseSearch && infosSearch.scopeSearch==="fr"){
          response.data.features.unshift({
            geometry:{
              coordinates : response.data.center,
              type :  "Point"
            },
            properties: {
              label:infosSearch.txtsearch,
              context:''
            }
          }); 
        }
        
        return response.data;
      }
      else if (response.status === 404) {
        return [];
      } 
    }).catch((err) => {
      if (err.response.status == 404) {
        return [];
      } 

      throw new Error("ERREUR API");
      return [];
    })
  }


  isReverse(textSearch) {
    if(textSearch.indexOf(" ") != -1) {
      const tab_adr = textSearch.trim().split(" ");
      if(tab_adr.length == 2) {
        if(isNaN(tab_adr[0]) == false && isNaN(tab_adr[1])  == false) {
            return true;
          }
      }
    }
    return false;
  }


  convertToReverse(textSearch) {

    if(textSearch.indexOf(" ") != -1) {
      const tab_adr = textSearch.split(" ");
      if(tab_adr.length == 2) {
          if(isNaN(tab_adr[1]) == false && isNaN(tab_adr[0])  == false) {
            textSearch = "&lon=" + parseFloat(tab_adr[1]) + "&lat=" + parseFloat(tab_adr[0]);
          }
      }
    }
    return textSearch;
  }

  isNumber(value) {
    return /^-?\d+(\.\d+)?$/.test(value);
  }

}

export default new AddressSearch();